function initGridder() {
    $(".gridder").gridderExpander({
      scroll: true,
      scrollOffset: 100,
      scrollTo: "panel", // panel or listitem
      animationSpeed: 1000,
      showNav: true,
      nextText: "<span></span>",
      prevText: "<span></span>",
      closeText: '<span class="close-panel">×</span>',
    });
  }

initGridder();